// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_app_tagline = /** @type {(inputs: {}) => string} */ () => {
	return `Adaptive Japanese language learning platform`
};

const id_app_tagline = /** @type {(inputs: {}) => string} */ () => {
	return `Platform pembelajaran bahasa Jepang yang adaptif`
};

const ja_app_tagline = /** @type {(inputs: {}) => string} */ () => {
	return `適応型日本語学習プラットフォーム`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const app_tagline = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.app_tagline(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("app_tagline", locale)
	if (locale === "en") return en_app_tagline(inputs)
	if (locale === "id") return id_app_tagline(inputs)
	return ja_app_tagline(inputs)
};
export { app_tagline as "app.tagline" }